import {DestroyRef, Directive, inject, input} from '@angular/core';
import {NgSelectComponent} from '@ng-select/ng-select';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

const HOST_CLASS = 'ms-drop-down';

@Directive({
  selector: '[msDropdown]',
  standalone: true,
  host: {
    [`[class.${HOST_CLASS}]`]: 'true',
    '[class.ms-drop-down--multiline]': 'multilineOptions()',
  },
})
export class DropdownDirective {
  readonly multilineOptions = input<boolean>(false);

  private readonly dropdown = inject(NgSelectComponent, {self: true});
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.init();
  }

  private init() {
    this.dropdown.searchable = false;
    this.dropdown.clearable = false;
    this.dropdown.selectOnTab = true;

    this.dropdown.classes = `${this.dropdown.classes || ''} ${HOST_CLASS}`;

    this.dropdown.openEvent.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.scrollToSelected();
    });
  }

  private scrollToSelected() {
    setTimeout(() => {
      const {dropdown} = this;

      if (dropdown.hasValue && dropdown.dropdownPanel) {
        const scrollElement = dropdown.dropdownPanel.scrollElementRef.nativeElement;
        const selectedElement = scrollElement.querySelector('.ng-option-selected') as HTMLElement;

        if (selectedElement) {
          scrollElement.scrollTop = selectedElement.offsetTop;
        }
      }
    });
  }
}
